import {Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {Client, ClientSearchTypes, PagedListOfClient, SystemData, User} from '../../../services/api.client';
import {ClientService} from '../../../services/ClientService';
import {ITableHeader, TableComponent} from '../../shared/table/TableComponent';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Masking} from '../../../utilities/Masking';
import {Observable} from 'rxjs';
import {SecurityService} from '../../../services/SecurityService';
// shared
// store
// models
// services
// utilities
// directives
// modals

@Component({
    selector: 'clientList',
    templateUrl: './ClientListComponent.html',
    styleUrls: ['./ClientListComponent.scss'],
    standalone: false
})

export class ClientListComponent implements OnInit {

  constructor(private _clientService: ClientService,
              private _router: Router,
              private _securityService: SecurityService) {
    this.currentUser$ = this._securityService.currentUser$;
    this.systemData$ = this._securityService.systemData$;
    this.loggedInUserType$ = this._securityService.currentUserUserType$;
  }
  searchTypePlaceholder = 'Search by SSN';
  ssnMask = Masking.ssnMask;
  form = new UntypedFormGroup({
    searchType: new UntypedFormControl('Ssn')
  });

  // subscriptions
  systemData: SystemData;
  systemData$: Observable<SystemData>;

  loggedInUserType: string;
  loggedInUserType$: Observable<string>;

  @ViewChild(TableComponent)
  table: TableComponent;

  // SSN/string search check box
  searchValue = '';

  // subscription
  currentUser: User;
  currentUser$: Observable<User>;

  // page-local search results (003-retire-ngrx follow-up: results must not
  // outlive the search criteria fields on this component)
  clients: Client[];
  pagedList: PagedListOfClient;

  // set Current Selected Client
  @Output()
  selectedClient = new EventEmitter<Client>();

  // sorting
  currentSortName = 'LastName';
  currentSorting = false;

  tableHeaders: ITableHeader[] = [
    {text: 'First Name', sortKey: 'FirstName'},
    {text: 'Last Name', sortKey: 'LastName', ascending: true},
    {text: 'Phone', sortKey: 'Phone', class: 'hidden-sm-down'},
    {text: 'SSN', sortKey: 'Last4Ssn', class: 'hidden-sm-down'},
    {text: 'Client Address', sortKey: 'Address1', class: 'hidden-sm-down'},
    {text: 'Zip Code', sortKey: 'ZipCode', class: 'hidden-sm-down'},
    {text: 'Employment', sortKey: 'EmploymentStatus', class: 'hidden-sm-down'},
  ];

  // pagination
  limit = 10;
  currentPage = 1;
  maxSize = 1;
  totalCount: number;

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(user => this.currentUser = user);
    this.systemData$.subscribe(systemData => this.systemData = systemData);
    this.loggedInUserType$.subscribe(loggedInUserType => this.loggedInUserType = loggedInUserType);
    this.searchTypePlaceholder = 'Search by SSN';
    let previous = 'Ssn';
    this.form.controls.searchType.valueChanges.subscribe(searchType => {
      if (searchType === 'Ssn') {
        this.searchValue = '';
        this.searchTypePlaceholder = 'Search by SSN';
      } else {
        if (previous === 'Ssn') {
          this.searchValue = '';
        }
        this.searchTypePlaceholder = 'Search by Name, Keyword, or Last 4 SSN';
      }
      previous = searchType;
    });
  }

  selectClient(client: Client): void {
    this.selectedClient.emit(client);

    // this._clientService.setCurrentClient(client);
    // this._router.navigate(['/app/client', client.id]);
  }

  sortClients(options: ITableHeader): void {
    this.currentSortName = options.sortKey;
    this.currentSorting = !options.ascending;
    this.filterClients();
  }

  setLimit(limit: number): void {// # of rows per page
    this.limit = limit;
    this.filterClients();
  }

  setPage(page: number): void {
    setTimeout(() => {
      this.currentPage = page; // set current page
      this.filterClients();
    });
  }

  // get clients
  filterClients(): void {
    const searchType = this.form.controls.searchType.value as ClientSearchTypes;

    const request = this._clientService.getClients(
      searchType,
      this.searchValue,
      this.currentUser.agency && this.currentUser.agency.id || '',
      this.currentSortName,
      this.currentSorting,
      this.limit,
      (this.currentPage - 1) * this.limit,
      null
    );
    this.table.request = request;
    request.subscribe({
      next: (pagedList) => {
        this.pagedList = pagedList;
        this.clients = pagedList?.items;
        this.totalCount = pagedList?.totalCount;
      }, error: () => {}
    });
  }

  // search value
  setSearchValue(searchValue): void {
    this.searchValue = searchValue;
  }
}
